import { render, staticRenderFns } from "./LabeledTextForm.vue?vue&type=template&id=12ce6060&"
import script from "./LabeledTextForm.vue?vue&type=script&lang=js&"
export * from "./LabeledTextForm.vue?vue&type=script&lang=js&"
import style0 from "./LabeledTextForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports